import React from 'react';

/**
 * De drie dingen die de dc-runtime tijdens het renderen deed en die de
 * gecompileerde JSX nog nodig heeft. Verder niets: alle sjabloonlogica staat nu
 * gewoon in de JSX zelf.
 */

/**
 * Eén {{ waarde }} uit de template.
 *
 * De runtime hing elke waarde in een <span class="sc-interp">. Dat lijkt overbodig,
 * maar zo'n span telt mee als vakje in de opmaak. Weglaten zou hier en daar iets
 * laten verschuiven, dus hij blijft staan.
 */
export function Interp({ v }) {
  if (v === undefined) return null;
  if (React.isValidElement(v) || Array.isArray(v)) return <>{v}</>;
  if (v === null || typeof v === 'boolean') return null;
  return <span className="sc-interp">{String(v)}</span>;
}

const kebabToCamel = (s) => s.replace(/-([a-z])/g, (_, c) => c.toUpperCase());

/**
 * Een stijl die uit renderVals komt kan een object zijn of een stuk CSS-tekst.
 * Beide kwamen voor, dus beide mogen hier langs.
 */
export function css(value) {
  if (value == null) return undefined;
  if (typeof value !== 'string') return value;
  const out = {};
  for (const decl of value.split(';')) {
    const i = decl.indexOf(':');
    if (i < 0) continue;
    const prop = decl.slice(0, i).trim();
    if (!prop) continue;
    out[prop.startsWith('--') ? prop : kebabToCamel(prop)] = decl.slice(i + 1).trim();
  }
  return out;
}

/** <sc-for> sloeg een lijst over die geen lijst was. Dat blijft zo. */
export function toList(value) {
  return Array.isArray(value) ? value : [];
}
